import React from 'react';

import ToolPage from '../partials/ToolPage';
import { Text, H2, Panel } from '@bigcommerce/big-design';

const MainError = () => {
  return(
    <ToolPage title="Barcode Inventory Management">
      <Panel>
        <H2>Failed to load payment</H2>
        <Text>Unable to resolve your store's subscription. If you're seeing this message, please contact support at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a>.</Text>
        <Text>Sorry for the inconvenience.</Text>
      </Panel>
    </ToolPage>
  )
}

export default MainError;
